'use strict';

export const UPDATE_DOMAIN_MODAL = 'UPDATE_DOMAIN_MODAL';
export const UPDATE_DOMAIN_MODAL_LOADING_STATUS = 'UPDATE_DOMAIN_MODAL_LOADING_STATUS';

// 更新弹出框状态（显示、隐藏）
export function updateDomainModal(modalItme = null, visible = false, opType = 'ADD') {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_DOMAIN_MODAL,
      modalItme,
      visible,
      opType,
    });
  }
}

export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_DOMAIN_MODAL_LOADING_STATUS,
      loading,
    });
  }
}